import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { ProgressComponent } from '@app/shared/progress/progress.component';

@NgModule({
  declarations: [ProgressComponent],
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, MatFormFieldModule, MatButtonModule, MatInputModule],
  exports: [ProgressComponent],
})
export class ProgressModule {}
